import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import InspectPropPreview from "../../features/previews/inspect_prop/InspectPropQuizPreview";
import { GetMigratedProperties } from "../../features/project_migration/InteractionMigrationHelper";
import InspectPropNodePreview from "../../features/sequence/node_previews/InspectPropNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import {
  InteractionProperty,
  InteractionPropertyType,
} from "../InteractionProperty";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";
import { InstantSpeedPropertiesEditor } from "../../features/interaction_properties_column/editors/InstantSpeedPropertiesEditor";

export interface IInspectProp extends Interaction {
  propId: string;
  tag: string;
}

export const requiredInspectProperties: InteractionProperty[] = [
  {
    id: "instant",
    name: "instant",
    locId: "instant",
    type: InteractionPropertyType.boolean,
    value: false,
  },
  {
    id: "speed",
    name: "Speed",
    locId: "speed",
    type: InteractionPropertyType.number,
    value: 1,
  },
];

export const inspectPropInteraction = (): InteractionFactoryEntity => {
  const view = <InspectPropPreview />;
  const filterType = "Inspect Prop";

  const create = (getKeys: (amount: number) => string[]): IInspectProp => {
    return {
      id: GetNewGuid(),
      name: "Inspect Prop",
      type: InteractionType.InspectProp,
      propId: "",
      tag: "",
      properties: requiredInspectProperties,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): Interaction => {
    if (interaction.properties === undefined)
      return { ...interaction, properties: requiredInspectProperties };

    // drill the props and add any missing ones
    var newProperties: InteractionProperty[] = GetMigratedProperties(
      requiredInspectProperties,
      interaction.properties
    );
    console.log(
      "[InspectProp] migrated " +
        (newProperties.length - interaction.properties.length) +
        " properties"
    );

    return { ...interaction, properties: newProperties };
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ) => {
    const converted = interaction as IInspectProp;
    return {
      ...converted,
      id: GetNewGuid(),
      properties: converted.properties ? [...converted.properties] : [],
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    currentTake: Take,
    actorPresets: Actor[]
  ) => {
    const converted = interaction as IInspectProp;
    const warnings: string[] = [];

    return warnings;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[],
    _getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext,
  ): SearchResultData[] => {
    const converted = interaction as IInspectProp;
    const searchableStrings = compactSearchableStrings(
      interaction.name,
      searchLookupContext?.getPropSearchTerms(converted.propId) ??
        converted.propId,
      converted.tag,
    );

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType
    );
  };

  const validateError = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    const converted = interaction as IInspectProp;
    const errors: string[] = [];

    if (converted.propId === "") errors.push("Prop is required");
    if (converted.tag === "") errors.push("Tag is required");

    return errors;
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <InspectPropNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    PropertiesEditor: InstantSpeedPropertiesEditor,
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
